import { metadata } from '@broadleaf/admin-components';

const EntityView = metadata.views.EntityView;

// FW doesn't expose these, which are required for making custom view components.
// The view components themselves do expose them, so this is a workaround. The
// exports listed here are actually common functions that are used in every view type.
const {
  useContextParams,
  useCurrentForm,
  useForms,
  useHandleSubmit,
  useIsReadOnly
} = EntityView.hooks;
const {
  getPrimaryComponents,
  getSecondaryComponents,
  isCreate,
  isInitializingForm,
  isMutable,
  isUpdate
} = EntityView.utils;

const {
  FetchActionTypes,
  RedirectActionTypes,
  useEntityState,
  defaultReducer,
  defaultState,
  startFetch,
  successFetch,
  failureFetch,
  queueFetch,
  redirectToBack,
  redirectToUpdate
} = EntityView.state;

export {
  useContextParams,
  useCurrentForm,
  useForms,
  useHandleSubmit,
  useIsReadOnly,
  getPrimaryComponents,
  getSecondaryComponents,
  isCreate,
  isUpdate,
  isInitializingForm,
  isMutable,
  FetchActionTypes,
  RedirectActionTypes,
  useEntityState,
  defaultReducer as entityViewDefaultReducer,
  defaultState as entityViewReducerDefaultState,
  startFetch,
  successFetch,
  failureFetch,
  queueFetch,
  redirectToBack,
  redirectToUpdate
};
